






























































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetShixunTimu$,
  SaveShixinQuestionResult$,
} from "@/request/shezhenjiaoxue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import PhotoPreview from "@/components/pic-preview.vue";
import CatalogDialog from "./catalogDialog.vue";
import Danxuan from "./danxuan.vue";
import Douxuan from "./duoxuan.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
    CatalogDialog,
    Danxuan,
    Douxuan,
  },
})
export default class SzjxSzsxDetail extends Vue {
  private cateId: any = "";
  private cateName: any = "";
  private questions: any[] = [];
  private current: any = 0;
  private ifShowCatalog: boolean = false;
  /**
   * @description 获得舌诊分类
   */
  private fetchDetail() {
    const loading = this.$loading({ text: "加载中..." });
    const params: any = {
      params: {
        cate_id: this.cateId,
      },
    };
    GetShixunTimu$(this, params)
      .then((data: any) => {
        this.questions = data;
      })
      .finally(() => {
        loading.close();
      });
  }

  /**
   * @description 打开目录
   */
  private openCatalog() {
    this.ifShowCatalog = true;
  }
  /**
   * @description 改变序号
   */
  private changeIndex(index) {
    this.current = index;
  }
  /**
   * @description 上一题
   */
  private prev() {
    this.current--;
  }
  /**
   * @description 下一题
   */
  private next() {
    this.current++;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.cateId = this.$route.query.id;
    this.cateName = this.$route.query.name;
    this.fetchDetail();
  }
}
